window.PostPreview = new function()
{
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('#post-preview-modal').on('hidden.bs.modal', function (e) {
            jQuery('body').addClass('modal-open');
        });

        jQuery('#post-preview-modal').on('shown.bs.modal', function (e) {
            var post_type = jQuery('.create-edit-post-v2-form input[name="post_type"]').val();

            var post_body = tinymce.activeEditor.getContent();
            post_body     = post_body.replace(/<\/?[^>]+(>|$)/g, "");
            jQuery('#post-preview-modal .post-title-text').text(post_body);

            var feat_img = jQuery('.create-edit-post-v2-form .img-container img').attr('src');
            jQuery('#post-preview-modal .img-wrap img').attr('src', feat_img);

            if(post_type == 'video') {
                var video = jQuery('.create-edit-post-v2-form .preview-video video source').attr('src');
                if(video) {
                    jQuery('#post-preview-modal video source').attr('src', video);
                    jQuery("#post-preview-modal video")[0].load();
                }
            }

            var post_flair = jQuery('.create-edit-post-v2-form select[name="flair"] option:selected').text();
            if(post_flair && post_flair != 'Select Flair') {
                jQuery('#post-preview-modal .post-flair').text(post_flair);
            } else {
                jQuery('#post-preview-modal .post-flair').remove();
            }

            var community = jQuery('.create-edit-post-v2-form select[name="community_id"] option:selected').text();
            if(community && community != 'Select Community') {
                jQuery('#post-preview-modal .crumb-preview .community').text(community);
            }

            var community_topic = jQuery('.create-edit-post-v2-form select[name="community_topic_id"] option:selected').text();
            if(community_topic && community_topic != 'Select Topic') {
                jQuery('#post-preview-modal .crumb-preview .community-topic').text(' > ' + community_topic);
            }

            var community_subtopic = jQuery('.create-edit-post-v2-form select[name="community_subtopic_id"] option:selected').text();
            if(community_subtopic && community_subtopic != 'Select Subtopic') {
                jQuery('#post-preview-modal .crumb-preview .community-subtopic').text(' > ' + community_subtopic);
            }

            if(post_type == 'link') {
                var external_title = jQuery('.create-edit-post-v2-form .external-title strong').text();
                jQuery('#post-preview-modal .external-title').text(external_title);
                jQuery('#post-preview-modal .external-excerpt').html(post_body);

                var external_body = jQuery('.create-edit-post-v2-form .external-content').text();
                jQuery('#post-preview-modal .external-container .post-body .body').text(external_body);

                var external_img = jQuery('.create-edit-post-v2-form .external_img').attr('src');
                jQuery('#post-preview-modal .feat-img-link').css('background-image', 'url(' + external_img + ')');
            }

            if(post_type == 'poll') {
                var question = jQuery('.create-edit-post-v2-form input[name="poll_question"]').val();
                jQuery('#post-preview-modal .question').text(question);
            }

            if(post_type == 'text' && jQuery('.create-edit-post-v2-form').hasClass('fun-news-create-post-form')) {
                jQuery('#post-preview-modal .post-body').remove();
            }

            jQuery('#post-preview-modal .post.post-card').show();
        });

        jQuery('input[name="spoiler"]').change(function(event) {
            var type    = jQuery('.create-edit-post-v2-form .tab.active').data('tab-name');
            var spoiler = jQuery('.create-edit-post-v2-form input[name="spoiler"]').prop('checked');

            jQuery('.preview-post').attr('href', '/posts/preview?post_type=' + type + '&spoiler=' + spoiler);
        });

        // jQuery('.tab').click(function(event) {
        //     var type    = jQuery(this).data('tab-name');
        //     var spoiler = jQuery('.create-edit-post-v2-form input[name="spoiler"]').prop('checked');

        //     jQuery('.preview-post').attr('href', '/posts/preview?post_type=' + type + '&spoiler=' + spoiler);
        // });
    };
}

jQuery(document).ready(function($) {
    PostPreview.init();
});
